import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

import "./CountDown.css";

const CountDown = (props) => {
  CountDown.protoTypes = {
    time: PropTypes.number.isRequired,
    onTimeUp: PropTypes.func,
    className: PropTypes.string,
  };

  // eslint-disable-next-line no-unused-vars
  const [biasTime, setBiasTime] = useState(new Date().getTime() + props.time);

  const calculateTimeLeft = () => {
    let difference = biasTime - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    if (isEmpty(timeLeft)) {
      if (props.onTimeUp) props.onTimeUp();
    }
  }, [timeLeft, props]);

  return (
    <div className="helbest-countdown">
      {!isEmpty(timeLeft) ? `${timeLeft.minutes} : ${timeLeft.seconds}` : null}
    </div>
  );
};

export default CountDown;
